import { createElementBlock as e, openBlock as o, createElementVNode as r } from "vue";
import l from "./index289.js";
const n = {}, s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function a(c, t, p, i, d, f) {
  return o(), e("svg", s, t[0] || (t[0] = [
    r("path", {
      fill: "currentColor",
      d: "M11.33 2.664a.75.75 0 0 1 1.34 0l2.64 5.262 5.783.722a.75.75 0 0 1 .49 1.216l-.047.052-4.112 4.205 1.133 5.734a.75.75 0 0 1-.996.849l-.062-.027L12 18.065l-5.5 2.612a.75.75 0 0 1-1.067-.756l.01-.066 1.132-5.734-4.111-4.205a.75.75 0 0 1 .374-1.256l.07-.012 5.78-.722Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ l(n, [["render", a]]);
export {
  u as default
};
